import { defineStore, acceptHMRUpdate } from 'pinia';
import { ref } from 'vue';

const useTitle = defineStore('title', () => {
  const title = ref<string>('');
  const subtitle = ref<string>('');

  const updateTitle = (newTitle: string) => {
    title.value = newTitle;
  };

  const updateSubtitle = (newSubtitle: string) => {
    subtitle.value = newSubtitle;
  };

  const getTitle = () => {
    return title.value;
  };

  const getSubtitle = () => {
    return subtitle.value;
  };

  const getFullTitle = () => {
    const title = getTitle()
      .replace(/ *\\?\n/g, ' ')
      .replace(/\*\*/g, '')
      .trim();
    const subtitle = getSubtitle()
      .replace(/ *\\?\n/g, ' ')
      .replace(/\*\*/g, '')
      .trim();
    return `${title}${subtitle ? `: ${subtitle}` : ''}`;
  };

  return {
    title,
    subtitle,
    updateTitle,
    updateSubtitle,
    getTitle,
    getSubtitle,
    getFullTitle
  };
});

export default useTitle;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTitle, import.meta.hot));
}
